import { z } from "zod";

/**
 * ControlePatrimonioSchema
 */

export const ControlePatrimonioSchema = z.object({
  idMaquinaEquip: z.coerce.number({ invalid_type_error: 'Este campo precisa ser prenchido!' }),
  dataEntrega: z.coerce.date().nullable().default(null),
  dataDevolucao: z.coerce.date().nullable().default(null),
  observacoes: z.string().nullable().default(null),
  files: z.instanceof(File).nullable().default(null),
  limparArquivos: z.coerce.boolean().default(false),
});

/**
 * ControlePatrimonioForm
 */

export type ControlePatrimonioForm = z.infer<typeof ControlePatrimonioSchema>;